import { BrandLogo } from '@bs/ui-components'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

/** The unbordered destructive banner three auth pages (claim-profile, forgot-password,
 *  reset-password) each hand-rolled identically — `className` overrides only the spacing, since
 *  the one caller with a companion success banner (login-page) needs its own bordered variant. */
export function FormError({ message, className = 'mt-6' }: { message: string; className?: string }) {
  return (
    <div role="alert" className={`${className} rounded-xl bg-destructive/5 px-4 py-3 text-sm text-destructive`}>
      {message}
    </div>
  )
}

export function AuthPageShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <header className="flex h-[92px] shrink-0 items-center bg-white px-4 shadow-[0_0_4px_rgba(0,0,0,0.25)] sm:px-[30px]">
        <BrandLogo />
      </header>

      <main className="flex min-h-[calc(100vh-92px)] flex-1 flex-col px-4 sm:px-6">
        <div className="flex flex-1 items-center justify-center py-16 sm:py-20">{children}</div>

        <footer className="mx-auto w-full max-w-[1392px] pb-6 text-center text-primary">
          <div className="flex items-center justify-center gap-4 py-2 text-sm">
            <span>Powered by</span>
            <BrandLogo />
          </div>
          <div className="border-t border-[#c7c7c7] pt-6">
            <div className="flex justify-center gap-10 text-sm text-[#404040]">
              <Link to="/terms">Term of use</Link>
              <Link to="/privacy">Privacy Policy</Link>
            </div>
            <p className="mt-10 text-xs text-[#404040]">
              Copyright © 2026. All rights reserved.
            </p>
          </div>
        </footer>
      </main>
    </div>
  )
}
